import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    
    data:{
        tags:[],
        word:'',
        list:null,
        show:false
    },
    lists: [
        {
            name:"Rezepte",
            target:"entities",
            variable:'name',
            constraint:{
                field: "entitycategory_id",
                value: "1"
            }
        },
        {
            name:"Zutaten",
            target:"entities",
            variable:'name',
            constraint:{
                field: "entitycategory_id",
                value: "2"
            }
        },
        {
            name:"Lieferanten",
            target:"companies",
            variable:'name',
            constraint:{
                field: "companycategory_id",
                value: "2"
            }          
        },
        {
            name:"Kunden",
            target:"companies",
            variable:'name',
            constraint:{
                field: "companycategory_id",
                value: "1"
            }   
        },
        {
            name:"Adressen",
            target:"adresses",
            variable:'street',
            constraint:{
                field: "",
                value: ""
            }   
        },
        {
            name:"Projekte",
            target:"projects",
            variable:'name',
            constraint:{
                field: "",
                value: ""
            }   
        },
        
    ],
    tagdata:{
        id:1,
        name:'formselect',
        attributes: {
            placeholder:"Tags",
            size:"xs10",
            invertedsize:"xs1",
            displaytitle:"name",
            displaysubtitle:"",
            multiple:true,
            icon:"search",
            variable: 'tags',
            setter: 'search/SEARCH_SET_TAGS',
            items:'tags/tags',
            withdialog:false,
        }                                    
    }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};